import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 整箱运价详情-限重信息查询
export function queryEffectivePriceWeightLimit(data) {
  return request({
    url: URL.price.priceWeightLimit.queryEffectivePriceWeightLimit,
    method: 'post',
    data
  })
}
// 整箱限重信息-待审核列表查询
export function queryPendingPriceWeightLimit(data) {
  return request({
    url: URL.price.priceWeightLimit.queryPendingPriceWeightLimit,
    method: 'post',
    data
  })
}
// 整箱限重信息-保存
export function save(data) {
  return request({
    url: URL.price.priceWeightLimit.save,
    method: 'post',
    data
  })
}
// 整箱限重信息-批量删除
export function deletePriceWeightLimits(data) {
  return request({
    url: URL.price.priceWeightLimit.deletePriceWeightLimits,
    method: 'post',
    data
  })
}
// 整箱限重信息-批量审核
export function approvePriceWeightLimits(data, params) {
  return request({
    url: URL.price.priceWeightLimit.approvePriceWeightLimits,
    method: 'post',
    data,
    params
  })
}
